export const PlayIcon = () => (
  <svg viewBox="0 0 89 89" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle
      cx="44.5"
      cy="44.5"
      r="43.5"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M71.6321 44.9797C55.2992 44.0166 40.4749 35.8125 30.805 24.0204C30.6441 23.7759 30.5033 24.0055 30.5686 24.0753L38.6345 45.0746L30.5737 66.2035C30.5737 66.2035 30.5385 66.6077 30.9005 66.3083C40.5705 54.6011 55.3646 46.1525 71.6321 45.1744C71.6321 45.1744 71.7276 45.1544 71.7276 45.0795C71.7276 45.0047 71.6321 44.9847 71.6321 44.9847V44.9797Z"
      fill="currentColor"
    />
  </svg>
)
